import {BBModel} from "../bb_model";

const membershipLevels = {
    getMembershipLevels(company) {
        return new Promise((resolve, reject) => {
            company.$get('member_levels').then(resource =>
                    resource.$get('membership_levels').then((membership_levels) => {
                            const levels = (Array.from(membership_levels).map(level => new BBModel.MembershipLevel(level)));
                            return resolve(levels);
                        }
                    )

                , (err) => {
                    return reject(err);
                }
            );
        });

    }
};

export {
    membershipLevels
}
